import React from 'react';
import { Card } from 'antd';
import { useRecoilState } from 'recoil';
import { themeState } from '../atom';

/**
 * The panel's card.
 *
 * `style` IS MERGED, NOT OVERWRITTEN. `{...props}` used to be spread before
 * this component's own `style`, so a caller passing `style={{ flex: 1 }}` had
 * it silently dropped — which is why rows of cards collapsed to their content
 * width instead of sharing the row. The caller's values win on conflict;
 * `height` and `boxShadow` below are only defaults.
 */
const CustomCard = ({ title, extra, children, height, style, ...props }) => {
  const theme = useRecoilState(themeState)
  const isDark = theme === 'dark' || (theme.length > 0 && theme[0] === "dark")
  return (
    <Card
      title={title}
      extra={extra}
      {...props}
      style={{
        height: (height) ? height : 'auto',
        boxShadow: isDark && '0px 1px 6px 1px #31608A4D',
        ...style,
      }}
      className={
        theme === 'light' || (theme.length > 0 && theme[0] === "light") ? 'theme-light-card' : 'theme-dark-card'
      }
    >
      {children}
    </Card>
  );
};

export default CustomCard;
